'use strict';

import controller from './restaurar.controller';
import template from './restaurar.html';

const RestaurarComponent = {
    bindings: {},
    controller,
    template
};

export default RestaurarComponent;


// WEBPACK FOOTER //
// ./src/app/components/admin/login/restaurar/restaurar.component.js